import { Link, useLocation } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";

import type { PathRouteType } from "$/lib/types/routes.types";
import { cn } from "$/lib/utils/functions/misc.functions";

type Props = {
  links: {
    label: string;
    route: PathRouteType;
    onClick?: () => void;
    badgeCount?: number;
  }[];
  className?: string;
};

const Navigation = ({
  links,
  className,
  children,
}: PropsWithChildren<Props>) => {
  const location = useLocation();

  return (
    <div
      className={cn(
        "flex w-full items-center justify-between border-border text-textColor",
        className,
      )}
    >
      <div className="flex w-full items-end justify-center border-border text-textColor md:justify-start">
        {links.map((link, index) => {
          const isActive = location.pathname === link.route;
          return (
            <Link
              key={index}
              to={link.route}
              onClick={link.onClick}
              className={cn(
                `relative max-w-48 flex-1 rounded-lg pb-3 screen850:py-3 text-center text-[15px] screen850:text-base font-medium text-textInfo after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-border after:content-['']`,
                "transition-all after:transition-all hover:text-primary hover:after:h-1 hover:after:bg-primary",
                {
                  "font-semibold text-primary after:h-1 after:w-full after:bg-primary":
                    isActive,
                },
              )}
            >
              <span className="relative inline-block">
                {link.label}
                {!!link.badgeCount && link.badgeCount > 0 && (
                  <span className="absolute -right-4 -top-2 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-notif text-tiny text-customWhite">
                    {link.badgeCount}
                  </span>
                )}
              </span>
            </Link>
          );
        })}
      </div>
      {children}
    </div>
  );
};

export default Navigation;
